import React from 'react'
import PropTypes from 'prop-types'

// presentational components
import { Loading } from 'components/shared'

const withApolloData = (WrappedComponent) => {
  const ApolloData = (props) => {
    const {
      data: { studios, studioPages } // from Apollo
    } = props

    // TODO: better way to differentiate between initial load and subsequent updates?
    if (!studioPages) { return <Loading /> }

    return <WrappedComponent
      {...props}
      studioPage={studioPages[0]}
      studioData={studios[0]}
    />
  }

  ApolloData.propTypes = {
    data: PropTypes.object.isRequired
  }

  return ApolloData
}

export default withApolloData
